import { FBProcedureProps, FBProcedureValue, FBProviderProps } from '..';
import { LHRS_ACCEPTED_QUANTITY, LHRS_REJECTED_QUANTITY, LHRS_START_QUANTITY } from '../FBLHRStep/utils';

// `type` is absent on old snapshots (procedure-only) and 'mpiprocedure' on new ones; anything else is a cloned
// MPI component whose own value is kept in `value` and rendered via FBSchemaState.component.
export type FBDeviationStepValue = FBProcedureValue & {
  stepIndex?: number
  mpiIndex?: number
  type?: string
  label?: string
  value?: unknown
  added?: boolean // component added in the deviation itself (not cloned from the MPI)
  schemaItem?: Record<string, unknown> // full MPI schema item (type, label, editorConfig, validators, ...)
};

// A PI Procedure added in the deviation is a plain added component, not a cloned MPI step
export const isDeviationProcedureStep = (step?: FBDeviationStepValue): boolean =>
  !step?.added && (!step?.type || step.type === 'mpiprocedure');

// MPI fields filled during LHR execution: shown in the deviation for context, always read-only
const READ_ONLY_MPI_FIELDS = [LHRS_START_QUANTITY, LHRS_ACCEPTED_QUANTITY, LHRS_REJECTED_QUANTITY];
export const isDeviationReadOnlyField = (stepId: string): boolean => READ_ONLY_MPI_FIELDS.includes(stepId);

export interface FBDeviationEditorConfig {
  [mpiId: string]: { [stepId: string]: FBDeviationStepValue }
}

export type FBDeviationProcedureProps =
  & Omit<FBProcedureProps, 'procedureState'>
  & Pick<FBProviderProps, 'deviationProcedureState'>
  & {
    editorConfig?: FBDeviationEditorConfig
    redlineActive?: boolean
    canEdit?: boolean
  };
